import { startCase } from 'lodash'
import React from 'react'
import helper from '../../utils/helpers'

import { useTranslation } from 'react-i18next'

const CustomerDetail = ({ item }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='relative  flex-auto'>
        <div className=' border-2 rounded-md p-5'>
          <div className='grid grid-cols-4 '>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('USERS_FULL_NAME')}:</strong>
              </div>
              {startCase(item?.firstName) + ' ' + startCase(item?.lastName)}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_MOBILE_NUMBER')}:</strong>
              </div>
              {item?.mobile || 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_EMAIL_ADDRESS')}:</strong>
              </div>
              {item?.email || 'N/A'}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_CREATED_AT')}:</strong>
              </div>
              {helper.dateFormat(item?.createdAt)}{' '}
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_ACTIVE_DE_ACTIVE')}:</strong>
              </div>
              <div className='flex justify-start items-center p-4'>
                <label className='inline-flex relative items-center '>
                  <input
                    type='checkbox'
                    className='sr-only peer'
                    checked={item?.status === 'active'}
                    disabled
                  />
                  <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CustomerDetail
